import { Container, Typography, Box, Paper } from '@mui/material';

function LegalNotice() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Mentions Légales
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            1. Informations légales
          </Typography>
          <Typography paragraph>
            Le site Up-Stage est édité par :
          </Typography>
          <Typography component="div" sx={{ ml: 2 }}>
            <Typography>Up-Stage SAS</Typography>
            <Typography>Société par Actions Simplifiée au capital de 10 000€</Typography>
            <Typography>RCS Nice 000 000 000</Typography>
            <Typography>Siège social : 13 avenue Simone Veil, 06200 Nice</Typography>
            <Typography>N° TVA Intracommunautaire : FR 00 000000000</Typography>
            <Typography>Email : contact@up-stage.fr</Typography>
            <Typography>Téléphone : 04 93 00 00 00</Typography>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            2. Direction de la publication
          </Typography>
          <Typography paragraph>
            Développement de Up-Stage SAS:
            <Typography sx={{ ml: 2 }}>- Luis Fernandes</Typography>
            <Typography sx={{ ml: 2 }}>- Egor Krichko</Typography>
            <Typography sx={{ ml: 2 }}>- Julien Braun</Typography>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            3. Hébergement
          </Typography>
          <Typography component="div" sx={{ ml: 2 }}>
            <Typography>Apache</Typography>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            4. Propriété intellectuelle
          </Typography>
          <Typography paragraph>
            L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé par le droit d'auteur. 
            Toute reproduction ou représentation totale ou partielle de ce site par quelque procédé que ce soit, 
            sans autorisation expresse, est interdite et constituerait une contrefaçon sanctionnée par les articles 
            L.335-2 et suivants du Code de la propriété intellectuelle.
          </Typography>
          <Typography paragraph>
            Les marques et logos figurant sur le site sont des marques déposées par Up-Stage SAS ou ses partenaires. 
            Toute reproduction totale ou partielle de ces marques ou logos sans autorisation expresse est prohibée.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            5. Protection des données personnelles
          </Typography>
          <Typography paragraph>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et 
            Libertés modifiée, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité 
            de vos données personnelles, ainsi que d'un droit d'opposition et de limitation du traitement. 
            Pour exercer ces droits, contactez-nous à : contact@up-stage.fr
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>
            6. Conditions générales d'utilisation
          </Typography>
          <Typography paragraph>
            L'utilisation de ce site est soumise aux présentes conditions générales d'utilisation. 
            En accédant à ce site, vous vous engagez à les respecter. Ces conditions peuvent être modifiées 
            à tout moment et sans préavis.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default LegalNotice;
